import React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import Labels from 'enums/Labels';
import InputDate from 'FormInputs/InputDate/InputDate';

import './InputDateOfBirth.css';

type Props = {
  onBlurHandler?: () => void;
};

class InputDateOfBirth extends React.Component<Props> {

  handleChange = (): void => {
    const {
      onBlurHandler,
    } = this.props;
    if (onBlurHandler) {
      onBlurHandler();
    }
  };

  render() {
    return (
      <Field name="birthDate">
        {({ input, meta }: FieldRenderProps<string>): React.ReactElement => (
          <InputDate
            labelWrapperClass="form-input"
            label={Labels.PERSONAL_DETAILS_BIRTHDATE}
            meta={meta}
            input={input}
            isRequired={true}
            onChangeHandler={(e) => { input.onChange(e); this.handleChange(); }}
            onBlurHandler={(e) => input.onBlur(e)}
          />
        )}
      </Field>
    );
  }
}

export default InputDateOfBirth;
